import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, throwError, } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EnvironmentConfiguration } from '../environment/services/environment.configuration';
var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
var httpOptions;
if (isIEOrEdge) {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
    })
  };
} else {
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': localStorage.getItem('Ebom_accessToken'),
      'x-api-key':localStorage.getItem('Filename')
    })
  };
}
@Injectable({
  providedIn: 'root'
})
export class HunderedSpecificationsService {

  namc = '/getNamcHps/{proxy+}';
  family = '/getFamilyByNamcHps/{proxy+}';
  hikiate = '/getHikiateStatusHps/{proxy+}';
  destination = '/getDestByKatashikiHps/{proxy+}';
  katashiki = "/getKatashikiHps/{proxy+}";
  pcSpec = "/getPcSpecHps/{proxy+}";
  gridData = '/getHunPerSpecGrid/{proxy+}';

  constructor(private http: HttpClient, private environment: EnvironmentConfiguration) { }

  //grid data
  getGridData(gridData): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let gridParams = new HttpParams().set('namc', gridData.namc)
    //   .append('family', gridData.family)
    //   .append('katashiki', gridData.katashiki)
    //   .append('destination', gridData.dest)
    //   .append('hikiate', gridData.hikiate)
    //   .append('pcSpec', gridData.pcSpec)
    //   .append('comment', gridData.comments)
    //   .append('hunSpecId', gridData.hundPercent)
    //   .append('vdwEffIn', gridData.vdwEffIn)
    //   .append('vdwEffOut', gridData.vdwEffOut)
    //   .append('timeInDt', gridData.timeInDt)
    //   .append('timeOutDt', gridData.timeOutDt)
    //   .append('option', gridData.option)
    let API_URL = this.environment.MastergridapiUrl  + this.gridData + '?namc=' + gridData.namc
      + '&family=' + gridData.family + '&katashiki=' + gridData.katashiki + '&destination=' + gridData.dest
      + '&hikiate=' + gridData.hikiate + '&pcSpec=' + gridData.pcSpec + '&comment=' + gridData.comments
      + '&hunSpecId=' + gridData.hundPercent + '&vdwEffIn=' + gridData.vdwEffIn + '&vdwEffOut=' + gridData.vdwEffOut
      + '&timeInDt=' + gridData.timeInDt + '&timeOutDt=' + gridData.timeOutDt + '&option=' + gridData.option+'&screenNo=NBPC_9178'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
  }

  //namc
  getNamcHps(): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.namc+'?screenNo=NBPC_9178'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //family
  getFamilyHps(namc): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let famParams = new HttpParams().set('namcId', namc)
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.family + '?namcId=' + namc+'&screenNo=NBPC_9178'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //hikiate
  getHikiateStatusHps(namc, family, katashiki, destination): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let hikiParams = new HttpParams().set('namcId', namc).append('famCd', family)
    //   .append('katashikiCd', katashiki).append('destId', destination)
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.hikiate + '?namcId=' + namc +
      '&famCd=' + family + '&katashikiCd=' + katashiki + '&destId=' + destination+'&screenNo=NBPC_9178'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //destination
  getDestHps(katashiki): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let destParams = new HttpParams().set('katashikiCd', katashiki)
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.destination + '?katashikiCd=' + katashiki+'&screenNo=NBPC_9178'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //katashiki
  getKatashikiHps(namc, family): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let katasParams = new HttpParams().set('namcId', namc).append('famCd', family)
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.katashiki + '?namcId=' + namc +
      '&famCd=' + family+'&screenNo=NBPC_9178'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }

  //psSpec
  getPcSpecHps(namc, family, katashiki, destination, hikiate): Observable<any> {
    var isIEOrEdge = /msie\s|trident\/|edge\//i.test(window.navigator.userAgent);
    let fileName= localStorage.getItem('Filename')
    var httpOptions;
    if (isIEOrEdge) {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Cache-Control': 'no-cache',
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Dec 2001 00:00:00 GMT',
        })
      };
    } else {
      httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': localStorage.getItem('Ebom_accessToken'),
          'x-api-key':localStorage.getItem('Filename')
        })
      };
    }
    // let katasParams = new HttpParams().set('namcId', namc)
    //                                   .append('famCd', family)
    //                                   .append('katashikiCd', katashiki)
    //                                   .append('destId', destination)
    //                                   .append('hikiateStatus', hikiate);
    let API_URL = this.environment.Mastersearchdropdown2apiUrl + this.pcSpec + '?namcId=' + namc +
      '&famCd=' + family + '&katashikiCd=' + katashiki + '&destId=' + destination + '&hikiateStatus=' + hikiate+'&screenNo=NBPC_9178'+'&fileName=' +fileName
    return this.http.get(API_URL, httpOptions)
      .pipe(
        catchError(this.error)
      )
  }


  // Handle Errors 
  error(error: HttpErrorResponse) {
    let errorMessage: any = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = error.status;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}
